import { warn } from "@swivl-mono/helpers";

export type SwivlNavigateFunction = (path: string|number, fromTitle?: any) => void;

export class NavigationHelper {
    static navFunction?: SwivlNavigateFunction 
    static navigate = (to?:string) => {
        if (!NavigationHelper.navFunction) {
            warn("NavigationHelper.navFunction not set. Can't navigate.");
            return;
        }
        if (!to) {
            warn("NavigationHelper.navigate called with no destination. Can't navigate.");
            return;
        }
        NavigationHelper.navFunction(to);
    }
}